<template>
  <el-form
    ref="ruleFormRef"
    :model="ruleForm"
    :rules="rules"
    label-width="110px"
    class="demo-ruleForm"
    size="large"
    status-icon
    v-loading="loading"
  >
    <el-form-item label="模板标题" prop="title">
      <el-input
        class="middle_input"
        clearable
        v-model="ruleForm.title"
        placeholder="请填写模板标题"
      />
    </el-form-item>
    <el-form-item label="模板文件类别" prop="classs">
      <el-select
        v-model="ruleForm.classs"
        class="m-2 middle_input"
        placeholder="请选择模板文件类别"
        size="large"
      >
        <el-option
          v-for="item in classList"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="模板内容" prop="content">
      <el-input
        class="textarea"
        v-model="ruleForm.content"
        type="textarea"
        placeholder="请输入模板内容"
      />
    </el-form-item>
  </el-form>
  <div slot="footer" class="from_btn">
    <el-button @click="resetForm" size="large">取消</el-button>
    <el-button type="primary" size="large" @click="submitForm(ruleFormRef)"
      >提交</el-button
    >
  </div>
</template>

<script>
import {
  getAllClasses,
  getTemplateDetail,
  addTemplate,
  editTemplate,
} from "network/templateFile.js";
import { toRefs, reactive, ref, unref, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";

export default {
  name: "AddEditTemplateFile",
  components: {},
  emits: {
    "close-dialog": null,
    "update-list": null,
  },
  props: {
    editId: Number,
  },
  setup(props, { emit }) {
    const ruleFormRef = ref();
    const data = reactive({
      loading: false,
      ruleForm: {
        title: "",
        classs: null,
        content: "",
      },
      rules: {
        title: [{ required: true, message: "请填写模板标题" }],
        classs: [
          {
            required: true,
            message: "请选择模板文件类别",
          },
        ],
        content: [
          {
            required: true,
            message: "请设置模板内容",
          },
        ],
      },
      classList: [],
    });
    onMounted(() => {
      getClass(); //获取模板文件类别
      //编辑-获取详情
      if (props.editId > 0) {
        data.loading = true;
        getTemplateDetail(props.editId)
          .then((result) => {
            if (result && result.code == 1) {
              data.loading = false;
              data.ruleForm = result.result;
              data.ruleForm.content = data.ruleForm.content;
            } else {
              data.loading = false;
              ElMessage.error(result.message);
            }
          })
          .catch(() => {
            data.loading = false;
          });
      }
    });
    //
    function getClass() {
      getAllClasses().then((res) => {
        if (res.code == 1) {
          data.classList = res.result;
        } else {
          ElMessage.error(res.message);
        }
      });
    }

    // 提交
    const submitForm = async () => {
      const form = unref(ruleFormRef);
      if (!form) return;
      try {
        const valid = await form.validate();
        if (!valid) {
          return false;
        } else {
          updataAdd();
        }
      } catch (error) {
        ElMessage.error("有必填内容未填写！");
        console.log(error);
      }
    };
    async function updataAdd() {
      data.loading = true;
      let content = JSON.parse(JSON.stringify(data.ruleForm.content));
      data.ruleForm.content = content; //编码传给接口
      // data.ruleForm.content = encodeURIComponent(content); //编码传给接口
      let result = "";
      if (props.editId > 0) {
        data.ruleForm.id = props.editId;
        result = await editTemplate(data.ruleForm);
      } else {
        result = await addTemplate(data.ruleForm);
      }
      if (result && result.code == 1) {
        data.loading = false;
        ElMessageBox.alert(result.message, props.editId > 0 ? "编辑" : "添加", {
          confirmButtonText: "确定",
                  });
            emit("close-dialog");
            emit("update-list");
      } else {
        data.loading = false;
        ElMessageBox.alert(result.message, props.editId > 0 ? "编辑" : "添加", {
          confirmButtonText: "确定",
                });
      }
    }

    // 取消操作  关闭弹窗
    const resetForm = () => {
      emit("close-dialog");
      ruleFormRef.value.resetFields();
    };
    return {
      ...toRefs(data),
      submitForm,
      ruleFormRef,
      resetForm,
    };
  },
};
</script>
<style scoped>
:deep(.el-input__inner) {
  outline: none;
  line-height: 1px;
}

.demo-ruleForm {
  width: 100%;
  height: 550px;
}
.textarea >>> .el-textarea__inner {
  width: 629px !important;
  height: 376px !important;
}
</style>

